var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, InputTextarea, Typography } from "@uigovpe/components";
import { useCallback, useEffect, useMemo, useState, } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getApiErrorMessage } from "../../../apis/http";
import { getHearingById } from "../../../apis/hearings";
import { createHearingContribution, getHearingItems, getMyHearingContribution, updateHearingContribution, } from "../../../apis/hearingParticipation";
import { useAuth } from "../../auth/AuthContext";
import { HearingResultsPanel } from "../components/HearingResultsPanel";
import { buildHearingAnswerMap, buildHearingAnswersPayload, canContributeToHearing, canShowHearingResults, findMissingRequiredHearingItems, formatHearingAnswerDisplay, sortHearingItems, } from "../utils/participation";
var DESCRIPTION_PREVIEW_LENGTH = 220;
var normalizeAnswerValue = function (value) {
    if (Array.isArray(value)) {
        return value.slice().sort().join("|");
    }
    return (value || "").trim();
};
var getTabFromSearchParams = function (searchParams) {
    return searchParams.get("tab") === "responses" ||
        searchParams.get("tab") === "results"
        ? "responses"
        : "questions";
};
var pageShellStyle = {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    padding: "32px 16px 48px",
};
var pageContainerStyle = {
    display: "grid",
    gap: 24,
    maxWidth: 960,
    width: "100%",
};
var titleCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    borderTop: "8px solid #0B4F8C",
    display: "grid",
    gap: 8,
    padding: 16,
};
var tabsBarStyle = {
    borderBottom: "1px solid #D1D5DB",
    display: "flex",
    gap: 4,
};
var tabButtonStyle = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: 14,
    padding: "8px 16px",
    position: "relative",
};
var feedbackStyles = {
    error: { background: "#FFE4E4", color: "#7A1F1F" },
    info: { background: "#E6F3FF", color: "#0B4F8C" },
    success: { background: "#EAFBD7", color: "#245C15" },
    warning: { background: "#FFF7D6", color: "#7A5800" },
};
var feedbackBoxStyle = {
    borderRadius: 12,
    padding: "12px 16px",
};
var questionCardStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
    display: "grid",
    gap: 16,
    padding: 24,
};
var inputGroupStyle = {
    display: "grid",
    gap: 8,
};
var optionRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
};
var clearSelectionStyle = {
    background: "transparent",
    border: "none",
    color: "#1451B4",
    cursor: "pointer",
    fontSize: 13,
    justifySelf: "end",
    padding: 0,
};
var fieldErrorStyle = {
    color: "#B42318",
    fontSize: 13,
    marginTop: 4,
};
var REQUIRED_FIELD_MESSAGE = "Campo obrigatório";
var getQuestionElementId = function (itemId) { return "hearing-question-".concat(itemId); };
var FeedbackBox = function (_a) {
    var message = _a.message, severity = _a.severity;
    return (_jsx("div", __assign({ style: __assign(__assign({}, feedbackBoxStyle), feedbackStyles[severity]) }, { children: _jsx(Typography, { children: message }) })));
};
var FormTabButton = function (_a) {
    var active = _a.active, label = _a.label, onClick = _a.onClick;
    return (_jsxs("button", __assign({ "aria-pressed": active, onClick: onClick, style: __assign(__assign({}, tabButtonStyle), { color: active ? "#1451B4" : "#6B7280", fontWeight: active ? 700 : 500 }), type: "button" }, { children: [label, active ? (_jsx("span", { style: {
                    background: "#1451B4",
                    borderRadius: 999,
                    bottom: -1,
                    height: 3,
                    left: 0,
                    position: "absolute",
                    right: 0,
                } })) : null] })));
};
var FooterActions = function (_a) {
    var canSubmit = _a.canSubmit, hasExisting = _a.hasExisting, isDirty = _a.isDirty, onClear = _a.onClear, onSubmit = _a.onSubmit, submitting = _a.submitting;
    return (_jsxs("div", __assign({ style: {
            alignItems: "center",
            display: "flex",
            gap: 16,
            justifyContent: "space-between",
            marginTop: 8,
        } }, { children: [_jsx(Button, { label: "Limpar formul\u00E1rio", link: true, onClick: onClear, severity: "secondary" }), _jsx(Button, { disabled: submitting || (hasExisting ? !isDirty : false) || !canSubmit, label: submitting
                    ? "Enviando..."
                    : hasExisting
                        ? "Atualizar contribuição"
                        : "Enviar", onClick: onSubmit })] })));
};
export var HearingFormPage = function () {
    var id = useParams().id;
    var hearingId = Number(id);
    var hasValidHearingId = Number.isFinite(hearingId) && hearingId > 0;
    var navigate = useNavigate();
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var _b = useAuth(), accessToken = _b.accessToken, hasToken = _b.hasToken, isAuthenticated = _b.isAuthenticated, isLoadingAuth = _b.isLoadingAuth;
    var _c = useState(null), hearing = _c[0], setHearing = _c[1];
    var _d = useState([]), items = _d[0], setItems = _d[1];
    var _e = useState({}), answers = _e[0], setAnswers = _e[1];
    var _f = useState({}), initialAnswers = _f[0], setInitialAnswers = _f[1];
    var _g = useState(null), existing = _g[0], setExisting = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState(false), submitting = _j[0], setSubmitting = _j[1];
    var _k = useState(null), activeFeedback = _k[0], setActiveFeedback = _k[1];
    var _l = useState(null), pageError = _l[0], setPageError = _l[1];
    var _m = useState(function () {
        return getTabFromSearchParams(searchParams);
    }), selectedTab = _m[0], setSelectedTab = _m[1];
    var _o = useState(false), descriptionExpanded = _o[0], setDescriptionExpanded = _o[1];
    var _p = useState({}), fieldErrors = _p[0], setFieldErrors = _p[1];
    var sortedItems = useMemo(function () { return sortHearingItems(items); }, [items]);
    var openForContribution = hearing
        ? canContributeToHearing(hearing.status)
        : false;
    var showAggregateResults = hearing
        ? canShowHearingResults(hearing.status)
        : false;
    var canSubmitAnswers = Boolean(accessToken) &&
        openForContribution &&
        (hearing === null || hearing === void 0 ? void 0 : hearing.contributionType) === "with_form";
    var isDirty = useMemo(function () {
        return sortedItems.some(function (item) {
            return normalizeAnswerValue(answers[item.id]) !==
                normalizeAnswerValue(initialAnswers[item.id]);
        });
    }, [answers, initialAnswers, sortedItems]);
    var description = (hearing === null || hearing === void 0 ? void 0 : hearing.description) || "";
    var descriptionNeedsToggle = description.length > DESCRIPTION_PREVIEW_LENGTH;
    var visibleDescription = descriptionExpanded || !descriptionNeedsToggle
        ? description
        : "".concat(description.slice(0, DESCRIPTION_PREVIEW_LENGTH).trim(), "...");
    var syncContribution = useCallback(function (itemsForMap) {
        if (itemsForMap === void 0) { itemsForMap = []; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, mapped, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!accessToken || !hasValidHearingId) {
                            setExisting(null);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getMyHearingContribution(hearingId, accessToken)];
                    case 2:
                        response = _b.sent();
                        mapped = buildHearingAnswerMap(response.data.answers || [], itemsForMap);
                        setExisting(response.data.contribution);
                        setAnswers(mapped);
                        setInitialAnswers(mapped);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        setExisting(null);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [accessToken, hasValidHearingId, hearingId]);
    useEffect(function () {
        setSelectedTab(getTabFromSearchParams(searchParams));
    }, [searchParams]);
    useEffect(function () {
        if (isLoadingAuth) {
            return;
        }
        if (!hasValidHearingId) {
            setPageError("Audiência inválida.");
            setLoading(false);
            return;
        }
        if (!(hasToken || isAuthenticated) || !accessToken) {
            setPageError("Faça login pelo Smartpass para responder a audiência.");
            setLoading(false);
            return;
        }
        var mounted = true;
        var load = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, hearingResponse, itemsResponse, nextItems, loadError_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        setPageError(null);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, Promise.all([
                                getHearingById(hearingId, accessToken),
                                getHearingItems(hearingId),
                            ])];
                    case 2:
                        _a = _b.sent(), hearingResponse = _a[0], itemsResponse = _a[1];
                        if (!mounted) {
                            return [2 /*return*/];
                        }
                        setHearing(hearingResponse.data.publicHearing);
                        nextItems = itemsResponse.data.items || [];
                        setItems(nextItems);
                        return [4 /*yield*/, syncContribution(nextItems)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        loadError_1 = _b.sent();
                        if (mounted) {
                            setPageError(getApiErrorMessage(loadError_1));
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        if (mounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        void load();
        return function () {
            mounted = false;
        };
    }, [
        accessToken,
        hasToken,
        hasValidHearingId,
        hearingId,
        isAuthenticated,
        isLoadingAuth,
        syncContribution,
    ]);
    var handleTabChange = function (nextTab) {
        setSelectedTab(nextTab);
        setSearchParams(nextTab === "responses" ? { tab: "responses" } : {});
    };
    var setAnswer = function (itemId, value) {
        setAnswers(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[itemId] = value, _a)));
        });
        setFieldErrors(function (current) {
            if (!current[itemId]) {
                return current;
            }
            var next = __assign({}, current);
            delete next[itemId];
            return next;
        });
    };
    var handleSelectMultipleChange = function (itemId, optionValue, checked) {
        setAnswers(function (current) {
            var _a;
            var previous = Array.isArray(current[itemId])
                ? current[itemId]
                : [];
            var next = checked
                ? __spreadArray(__spreadArray([], previous, true), [optionValue], false) : previous.filter(function (value) { return value !== optionValue; });
            return __assign(__assign({}, current), (_a = {}, _a[itemId] = next, _a));
        });
        setFieldErrors(function (current) {
            if (!current[itemId]) {
                return current;
            }
            var next = __assign({}, current);
            delete next[itemId];
            return next;
        });
    };
    var clearItemSelection = function (item) {
        if (item.type === "text") {
            setAnswer(item.id, "");
            return;
        }
        setAnswer(item.id, item.type === "select_multiple" ? [] : "");
    };
    var handleClear = function () {
        setAnswers({});
        setFieldErrors({});
        setActiveFeedback(null);
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var missingItems, nextErrors, firstMissingId_1, payload, submitError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hearing || !accessToken || !canSubmitAnswers) {
                        return [2 /*return*/];
                    }
                    missingItems = findMissingRequiredHearingItems(sortedItems, answers);
                    if (missingItems.length > 0) {
                        nextErrors = Object.fromEntries(missingItems.map(function (item) { return [item.id, REQUIRED_FIELD_MESSAGE]; }));
                        setFieldErrors(nextErrors);
                        setActiveFeedback(null);
                        firstMissingId_1 = missingItems[0].id;
                        window.requestAnimationFrame(function () {
                            var _a;
                            (_a = document
                                .getElementById(getQuestionElementId(firstMissingId_1))) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "center" });
                        });
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    setFieldErrors({});
                    setActiveFeedback(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    payload = {
                        answers: buildHearingAnswersPayload(sortedItems, answers),
                    };
                    if (!existing) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateHearingContribution(hearing.id, existing.id, payload, accessToken)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createHearingContribution(hearing.id, payload, accessToken)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [4 /*yield*/, syncContribution(sortedItems)];
                case 6:
                    _a.sent();
                    setActiveFeedback({
                        message: existing
                            ? "Contribuição atualizada com sucesso."
                            : "Contribuição enviada com sucesso.",
                        severity: "success",
                    });
                    setSearchParams({ tab: "responses" });
                    return [3 /*break*/, 9];
                case 7:
                    submitError_1 = _a.sent();
                    setActiveFeedback({
                        message: getApiErrorMessage(submitError_1),
                        severity: "error",
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var detailsPath = "/hearings/details/".concat((hearing === null || hearing === void 0 ? void 0 : hearing.id) || (hasValidHearingId ? hearingId : ""));
    return (_jsx("div", __assign({ style: pageShellStyle }, { children: _jsxs("div", __assign({ style: pageContainerStyle }, { children: [_jsx("div", { children: _jsxs("button", __assign({ onClick: function () { return navigate(detailsPath); }, style: {
                            alignItems: "center",
                            background: "#FFFFFF",
                            border: "1px solid #1451B4",
                            borderRadius: 8,
                            boxSizing: "border-box",
                            color: "#1451B4",
                            cursor: "pointer",
                            display: "inline-flex",
                            fontSize: 14,
                            fontWeight: 600,
                            gap: 8,
                            height: 32,
                            padding: "0 16px",
                        }, type: "button" }, { children: [_jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u2190" })), "Voltar para audi\u00EAncia"] })) }), activeFeedback ? _jsx(FeedbackBox, __assign({}, activeFeedback)) : null, loading || isLoadingAuth ? (_jsx(Typography, { children: "Carregando..." })) : pageError || !hearing ? (_jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(FeedbackBox, { message: pageError || "Audiência não encontrada.", severity: "error" }), _jsx("div", { children: _jsx(Button, { label: "Voltar para audi\u00EAncias", onClick: function () { return navigate("/"); } }) })] }))) : hearing.contributionType !== "with_form" ? (_jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(FeedbackBox, { message: "Esta audi\u00EAncia n\u00E3o utiliza formul\u00E1rio. Use o fluxo de contribui\u00E7\u00E3o aberta.", severity: "warning" }), _jsx(Button, { label: "Voltar para a audi\u00EAncia", onClick: function () { return navigate(detailsPath); } })] }))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: titleCardStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "lg" }, { children: hearing.title })), description ? (_jsxs("div", __assign({ style: { display: "grid", gap: 4 } }, { children: [_jsx(Typography, { children: visibleDescription }), descriptionNeedsToggle ? (_jsx("button", __assign({ onClick: function () { return setDescriptionExpanded(function (value) { return !value; }); }, style: {
                                                background: "transparent",
                                                border: "none",
                                                color: "#1451B4",
                                                cursor: "pointer",
                                                fontSize: 14,
                                                justifySelf: "start",
                                                padding: 0,
                                            }, type: "button" }, { children: descriptionExpanded ? "Ver menos" : "Ver mais" }))) : null] }))) : null] })), _jsxs("div", __assign({ style: tabsBarStyle }, { children: [_jsx(FormTabButton, { active: selectedTab === "questions", label: "Quest\u00F5es", onClick: function () { return handleTabChange("questions"); } }), _jsx(FormTabButton, { active: selectedTab === "responses", label: "Respostas", onClick: function () { return handleTabChange("responses"); } })] })), selectedTab === "responses" ? (showAggregateResults ? (_jsx(HearingResultsPanel, { hearingId: hearing.id })) : (_jsxs("div", __assign({ style: questionCardStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "medium" }, { children: "Suas respostas" })), existing ? (sortedItems.map(function (item) {
                                    var display = formatHearingAnswerDisplay(item, answers[item.id]);
                                    return (_jsxs("div", __assign({ style: { display: "grid", gap: 4 } }, { children: [_jsxs(Typography, __assign({ size: "sm", style: { color: "#6B7280" } }, { children: [item.order, ". ", item.description] })), _jsx(Typography, { children: display })] }), item.id));
                                })) : (_jsx(Typography, { children: "Envie o formul\u00E1rio na aba Quest\u00F5es para ver suas respostas. Os resultados agregados ficam dispon\u00EDveis ap\u00F3s o encerramento da audi\u00EAncia." }))] })))) : (_jsxs("div", __assign({ style: { display: "grid", gap: 24 } }, { children: [!openForContribution ? (_jsx(FeedbackBox, { message: "Esta audi\u00EAncia n\u00E3o est\u00E1 mais recebendo novas respostas.", severity: "warning" })) : null, sortedItems.length === 0 ? (_jsx("div", __assign({ style: questionCardStyle }, { children: _jsx(Typography, { children: "Nenhuma pergunta cadastrada para esta audi\u00EAncia." }) }))) : (_jsxs(_Fragment, { children: [sortedItems.map(function (item) {
                                            var hasSelection = item.type === "text"
                                                ? Boolean(String(answers[item.id] || "").trim())
                                                : item.type === "select_multiple"
                                                    ? Array.isArray(answers[item.id]) &&
                                                        answers[item.id].length > 0
                                                    : Boolean(answers[item.id]);
                                            return (_jsxs("div", __assign({ id: getQuestionElementId(item.id), style: questionCardStyle }, { children: [_jsxs(Typography, __assign({ fontWeight: "medium" }, { children: [item.order, ". ", item.description, item.isRequired ? (_jsx("span", __assign({ style: { color: "#DC2626" } }, { children: " *" }))) : null] })), item.type === "text" ? (_jsx(InputTextarea, { disabled: !canSubmitAnswers, onChange: function (event) {
                                                            return setAnswer(item.id, event.target.value);
                                                        }, placeholder: "Sua resposta", rows: 4, value: String(answers[item.id] || "") })) : item.type === "select_unique" ? (_jsxs("div", __assign({ style: inputGroupStyle }, { children: [(item.publicHearingItemOptions || []).map(function (option) { return (_jsxs("label", __assign({ style: optionRowStyle }, { children: [_jsx("input", { checked: answers[item.id] === option.value, disabled: !canSubmitAnswers, name: "hearing-item-".concat(item.id), onChange: function () {
                                                                            return setAnswer(item.id, option.value);
                                                                        }, type: "radio", value: option.value }), _jsx("span", { children: option.label })] }), option.id)); }), canSubmitAnswers && hasSelection ? (_jsx("button", __assign({ onClick: function () { return clearItemSelection(item); }, style: clearSelectionStyle, type: "button" }, { children: "Limpar sele\u00E7\u00E3o" }))) : null] }))) : (_jsxs("div", __assign({ style: inputGroupStyle }, { children: [(item.publicHearingItemOptions || []).map(function (option) {
                                                                var currentValues = Array.isArray(answers[item.id])
                                                                    ? answers[item.id]
                                                                    : [];
                                                                return (_jsxs("label", __assign({ style: optionRowStyle }, { children: [_jsx("input", { checked: currentValues.includes(option.value), disabled: !canSubmitAnswers, onChange: function (event) {
                                                                                return handleSelectMultipleChange(item.id, option.value, event.target.checked);
                                                                            }, type: "checkbox" }), _jsx("span", { children: option.label })] }), option.id));
                                                            }), canSubmitAnswers && hasSelection ? (_jsx("button", __assign({ onClick: function () { return clearItemSelection(item); }, style: clearSelectionStyle, type: "button" }, { children: "Limpar sele\u00E7\u00E3o" }))) : null] }))), fieldErrors[item.id] ? (_jsx("span", __assign({ role: "alert", style: fieldErrorStyle }, { children: fieldErrors[item.id] }))) : null] }), item.id));
                                        }), _jsxs("div", __assign({ style: { display: "grid", gap: 12 } }, { children: [existing && !isDirty ? (_jsx(Typography, __assign({ size: "sm", style: { color: "#6B7280" } }, { children: "Nenhuma altera\u00E7\u00E3o pendente para salvar." }))) : null, _jsx(FooterActions, { canSubmit: canSubmitAnswers, hasExisting: Boolean(existing), isDirty: isDirty, onClear: handleClear, onSubmit: function () { return void handleSubmit(); }, submitting: submitting })] }))] }))] })))] }))] })) })));
};
